<template>
	<div>
		<v-row class="d-flex flex-column justify-center align-center divProfileManagement shadow-blue-not-openned">
			<v-tooltip color="black" top>
				<template v-slot:activator="{ on }">
					<v-btn
						tile
						block
						depressed
						color="white"
						class="firstbutton btn-profile-management"
						:to="{ name: 'Parametres', query: { disableDashboardRedirect: true } }"
						v-on="on"
					>
						<span class="fs12 ortho-text-gray btn-profile-management-title">Paramètres</span></v-btn
					>
				</template>
				<span>Voir les paramètres</span>
			</v-tooltip>
			<v-tooltip color="black" top v-if="profileData.manager">
				<template v-slot:activator="{ on }">
					<v-btn
						tile
						block
						depressed
						color="white"
						class="centralbutton btn-profile-management"
						href="https://admin.orthographiq.com"
						v-on="on"
					>
						<span class="fs12 ortho-text-gray btn-profile-management-title">Console administrateur</span></v-btn
					>
				</template>
				<span>Voir les statistiques utilisateurs</span>
			</v-tooltip>
			<v-tooltip color="black" top>
				<template v-slot:activator="{ on }">
					<v-btn
						tile
						block
						depressed
						color="white"
						class="centralbutton btn-profile-management"
						href="https://docs.google.com/forms/d/e/1FAIpQLSezq8Kkh0Kv1y9o056Zy-5iNVDoBkC8Tf3Lo3HMYGIN4Q3iBg/viewform?usp=sf_link"
						target="_blank"
						v-on="on"
					>
						<span class="fs12 ortho-text-gray btn-profile-management-title">Améliorer la plateforme</span></v-btn
					>
				</template>
				<span>Aide-nous à améliorer la plateforme pour <br />qu'elle ressemble à ce dont tu as besoin.</span>
			</v-tooltip>
			<LogOutButton />
		</v-row>
	</div>
</template>

<script>
import LogOutButton from '@/components/logout/LogOutButton.vue';

export default {
	name: 'ProfileManagement',
	components: {
		LogOutButton,
	},
	props: {
		profileData: Object,
	},
};
</script>

<style lang="scss" scoped>
.btn-profile-management {
	&:hover {
		.btn-profile-management-title {
			color: #686bdf !important;
		}
	}
}

.title-container {
	text-align: center;
}
.firstbutton {
	border-bottom: 1px solid #f4f4f4 !important;
	border-top-left-radius: 4px !important;
	border-top-right-radius: 4px !important;
}
.centralbutton {
	border-bottom: 1px solid #f4f4f4 !important;
}

.divProfileManagement {
	border-radius: 4px;
}
</style>
